import React from 'react'
import PropTypes from 'prop-types' 
import { useTab } from './hooks'

export const TabLink = ({eventKey, className, children, ...props}) => {
    const { activeKey, setActiveKey } = useTab() 
    const show = activeKey === eventKey
    const handleClick = (e) => {
        e.preventDefault() 
        if(activeKey !== eventKey) {
            setActiveKey(eventKey)
        }
        window.location.hash = eventKey
    }
    return ( 
        <a {...props} href={`#${eventKey}`} className={`${className}${show ? ' active' : ''}`} onClick={handleClick} role='tab' aria-controls={eventKey} aria-selected={show}>
            {children}
        </a> 
    )
}

TabLink.propTypes = {
    eventKey: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
}
